var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"base-link",class:_vm.linkClasses},[(_vm.$props.icon)?_c('i',{staticClass:"icon",class:_vm.$props.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }